import { AppConfigService } from '@/src/app/core/services';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'aup-recaptcha',
  templateUrl: './recaptcha.component.html',
  styleUrls: ['./recaptcha.component.scss'],
  standalone: false,
})
export class RecaptchaComponent implements OnInit {
  @Output() onReCaptchaResolved: EventEmitter<string> = new EventEmitter<string>();

  public siteKey!: string;

  constructor(public appConfigService: AppConfigService) {}

  ngOnInit(): void {
    this.siteKey = this.appConfigService.getConfig()!.reCaptchaSiteKey;
  }
}
